import { api } from './axios'

/**
 * Drug List / Inventory (Phase 6) endpoints.
 *
 * Stock-changing operations always go through `/drugs/{id}/stock` (POST) so the
 * backend keeps a stock_movements audit trail. Stock fields are NEVER part of
 * `PATCH /drugs/{id}` — that endpoint is metadata-only.
 */
export const drugApi = {
  /* ---- Static reference data --------------------------------------------- */
  listCategories: () => api.get('/drugs/categories').then((r) => r.data),

  /* ---- CRUD -------------------------------------------------------------- */
  create: (payload) => api.post('/drugs', payload).then((r) => r.data),

  list: ({ search, category, filter, include_inactive, limit = 100, offset = 0 } = {}, opts = {}) =>
    api
      .get('/drugs', {
        params: { search, category, filter, include_inactive, limit, offset },
        ...opts,
      })
      .then((r) => r.data),

  get: (drug_id, opts = {}) => api.get(`/drugs/${drug_id}`, opts).then((r) => r.data),

  update: (drug_id, payload) =>
    api.patch(`/drugs/${drug_id}`, payload).then((r) => r.data),

  /** Soft-delete; returns { deactivated: drug_id }. Backend keeps the row. */
  remove: (drug_id) => api.delete(`/drugs/${drug_id}`).then((r) => r.data),

  /* ---- Stock movements --------------------------------------------------- */
  adjustStock: (drug_id, { delta, note }) =>
    api.post(`/drugs/${drug_id}/stock`, { delta, note }).then((r) => r.data),

  listMovements: (drug_id, { limit = 100, ...opts } = {}) =>
    api
      .get(`/drugs/${drug_id}/movements`, { params: { limit }, ...opts })
      .then((r) => r.data),
}
